import { ReduxAction } from 'actions';
import { FileActionType, StoreAdminMinioCredentialsAction } from '@actions/fileActions';
import { getAdminMinioCredentials_getAdminMinioCredentials } from '@api/graphql/types';

export interface FileReducer {
    credentials: getAdminMinioCredentials_getAdminMinioCredentials | null;
}

const initialState: FileReducer = {
    credentials: null,
};

export default function (state: FileReducer = initialState, action: ReduxAction) {
    switch (action.type) {
        case FileActionType.storeAdminMinioCredentials:
            const newState = { ...state };
            const credentials = (action as StoreAdminMinioCredentialsAction).credentials.getAdminMinioCredentials;
            if (credentials) {
                newState.credentials = credentials;
            }
            return newState;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/fileReducer.ts